export default {
  en: {
    'TOUR_DONT_SHOW_AGAIN': 'Don\'t show again',
    'TOUR_SKIP': 'Skip Tour',
    'TOUR_PREVIOUS': 'Previous',
    'TOUR_NEXT': 'Next',
    'TOUR_FINISH': 'Got it',
  }
};